export default __webpack_public_path__ + "static/Freight-SansMedium-1c157d35b963f1cd27330fc1e4b3453c.woff2";